import React from "react";
import "./style.css";

const ModalOverlay = props => (
  <div className="div_container">
    <div
      className="div_ModalOverlay"
      style={props.underLayerStyle}
      onClick={props.close}
    />
    <div className="div_modal" style={props.modalStyle}>
      {props.noTitle ? (
        ""
      ) : (
          <div className="div_modalHeader" style={props.headerStyle}>
            {props.iconSource != null ? (
              <img src={props.iconSource} alt="Header" />
            ) : (
                ""
              )}
            <p className="p_modalHeader" style={props.headerBodyStyle}>{props.header}</p>
          </div>
        )}
      <div
        className="div_modalBody"
        style={{
          borderRadius: props.noTitle
            ? "40px 40px 40px 40px"
            : "0px 0px 40px 40px",
          ...props.bodyStyle
        }}
      >
        {props.children}
      </div>
    </div>
  </div>
);

export default ModalOverlay;
